import { type RouteRecordRaw } from "vue-router"

import { type Permission } from "@/types"

const routes: RouteRecordRaw[] = [
  {
    path: "/bezugspersonen",
    name: "CustodiansPage",
    component: () => import("./CustodiansPage.vue"),
    meta: {
      requiredRoles: <Permission[]>["child:list", "child:unlock"],
    },
  },
]

export default routes
